import { Skeleton } from 'breeze-intelligence-kit';
import unescapedText from 'I18n/utils/unescapedText';

// Refer to https://hubspot.slack.com/archives/C06V7LMDN48/p1753205196129099
// bend-lint-disable-next-line strict-exports
import { useGetRecordLink } from 'crm-links/record/useGetRecordLink';
import { getObjectTypeIconComponent } from 'customer-data-objects-ui-components/objects/getObjectTypeIconComponent';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { useEffect, useState } from 'react';
import { useObjectTypeDefinition } from '../../ObjectTypeDefinitionsProvider/useObjectTypeDefinition';
import { jsx as _jsx } from "react/jsx-runtime";
export const CrmDataSourceButton = ({
  children,
  source
}) => {
  const {
    objectId,
    objectTypeId
  } = source;
  const {
    objectTypeDefinition,
    isLoading
  } = useObjectTypeDefinition(source.objectTypeId);
  const [href, setHref] = useState();
  const getRecordLink = useGetRecordLink();
  useEffect(() => {
    getRecordLink({
      objectId,
      objectTypeId
    }).then(link => {
      setHref(link === null || link === void 0 ? void 0 : link.href);
    }).catch(() => {});
  }, [getRecordLink, objectId, objectTypeId]);
  if (isLoading) {
    return /*#__PURE__*/_jsx(Skeleton, {
      variant: "breeze"
    });
  }
  const {
    singularForm
  } = objectTypeDefinition !== null && objectTypeDefinition !== void 0 ? objectTypeDefinition : {};
  const Icon = getObjectTypeIconComponent(objectTypeId);

  // TODO: Populate secondary text with the record's display label

  return children({
    primaryText: singularForm !== null && singularForm !== void 0 ? singularForm : unescapedText('citation.sourcesList.crmDataRecordFallbackLabel'),
    secondaryText: String(objectId),
    disabled: !href,
    onSourceClick: href ? () => window.open(href, '_blank', 'noopener,noreferrer') : undefined,
    icon: /*#__PURE__*/_jsx(IconCircle, {
      backgroundColor: "fill-primary-default",
      borderWidth: "0",
      color: "icon-primary-default",
      icon: Icon,
      padding: "100",
      size: "100"
    })
  });
};